// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4VyyB","col":"styles_col__Bgb3c","actions":"styles_actions__1-qKp","conflict":"styles_conflict__3Y3fr"};